/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-consumable-return-bill-item.reducer';

export const PharmacyConsumableReturnBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyConsumableReturnBillItemEntity = useAppSelector(state => state.pharmacyConsumableReturnBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyConsumableReturnBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.detail.title">
            PharmacyConsumableReturnBillItem
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="returnClaimed">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnClaimed">Return Claimed</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.returnClaimed}</dd>
          <dt>
            <span id="returnQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnQty">Return Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.returnQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.lastUpdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.pharmacyStock ? pharmacyConsumableReturnBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableReturnBillItemEntity.returnBill ? pharmacyConsumableReturnBillItemEntity.returnBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-consumable-return-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/pharmacy-consumable-return-bill-item/${pharmacyConsumableReturnBillItemEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyConsumableReturnBillItemDetail;
